export default __webpack_public_path__ + "static/media/trade-coin.15ce0bd0.svg";